'use client';

export const getSpecificStoreLocatorUrl = ({ store_code }) => {
  const url = `/store-locator/store-details?store_code=${store_code}`;

  return url;
};

export const getSpecificStoreClipboardCopy = ({ store_code }) => {
  const url = `${process.env.NEXT_PUBLIC_APP_URL}/store-locator/store-details?store_code=${store_code}`;

  return url;
};

export const generateHref = (
  destination,
  origin = null,
  travelMode = 'driving',
) => {
  const baseUrl = 'https://www.google.com/maps/dir/?api=1';

  if (origin !== null && origin !== undefined) {
    return `${baseUrl}&origin=${origin}&destination=${destination}&travelmode=${travelMode}`;
  }
  return `${baseUrl}&destination=${destination}&travelmode=${travelMode}`;
};

export const getPlaceholderStoreLocatorShareUrl = () => {
  const url = `${process.env.NEXT_PUBLIC_APP_URL}/store-locator`;
  return url;
};
